import script from "./ComparisonContentCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ComparisonContentCard.vue?vue&type=script&setup=true&lang=js"

import "./ComparisonContentCard.vue?vue&type=style&index=0&id=1970ca06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1970ca06"]])

export default __exports__